'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _aphrodite = require('aphrodite');

var _reactRouter = require('react-router');

var _reactRouterScroll = require('react-router-scroll');

var _createRoutes = require('create-routes');

var _createRoutes2 = _interopRequireDefault(_createRoutes);

var _gatsbyBrowser = require('gatsby-browser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadContext = require('.gatsby-context');


function loadConfig(callback) {
  var stuff = require('config');
  if (module.hot) module.hot.accept(stuff.id, callback);
  return callback();
}

_reactRouter.browserHistory.listen(function (location) {
  if (_gatsbyBrowser.onRouteChange) {
    (0, _gatsbyBrowser.onRouteChange)(location);
  }
});

var routes = void 0;
loadConfig(function () {
  loadContext(function (pagesReq) {
    var _require = require('config');

    var pages = _require.pages;

    if (!routes) {
      routes = (0, _createRoutes2.default)(pages, pagesReq);
      if (_gatsbyBrowser.modifyRoutes) {
        routes = (0, _gatsbyBrowser.modifyRoutes)(routes);
      }
    }

    if (typeof window !== 'undefined') _aphrodite.StyleSheet.rehydrate(window.__aphrodite__);
    render();
  });
});

function render() {
  var mount = typeof window !== 'undefined' ? document.getElementById('react-mount') : void 0;
  var handle = _gatsbyBrowser.scrollHandler || function () {
    return true;
  };
  var router = _react2.default.createElement(_reactRouter.Router, {
    history: _reactRouter.browserHistory,
    routes: routes,
    render: (0, _reactRouter.applyRouterMiddleware)((0, _reactRouterScroll.useScroll)(handle))
  });
  _reactDom2.default.render(router, mount);
}
//# sourceMappingURL=data:application/json;base64,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


/*****************
 ** WEBPACK FOOTER
 ** ../~/gatsby-asdf/dist/web-entry.js
 ** module id = 0
 ** module chunks = 0
 **/